import { get } from '@/tools/http';

export default {
    namespaced: true,

    state: {
        myInternship: [],
        total: 0,
    },
    mutations: {
        setMyInternship: (state, data) => {
            state.myInternship = data.data;
            state.total = data.total;
        },
    },
    actions: {
        loadMyInternship: async (ctx, { completed = null }) => {
            let res = [];
            try {
                await ctx.dispatch('data/loadRegistryItems', { type: 'spk_project_type' }, { root: true });
                const types = ctx.rootGetters['data/getRegistryItems']('spk_project_type').reduce((result, type) => {
                    result[type.field_name] = type.id;
                    return result;
                }, {});
                res = await get(
                    'projects2',
                    'api/v1/project/current',
                    {
                        completed: completed,
                        'filter[type]': types.internship,
                    },
                    true
                );
            } catch (e) {
                if (e.response.status === 404) {
                    res = {
                        data: [],
                        total: 0,
                    };
                }
            }
            res.data = res.data.map((item) => {
                if (item.nominations[0]) {
                    item.completed = completed === 'true';
                }
                return item;
            });
            ctx.commit('setMyInternship', res);
            return res;
        },
    },
    getters: {
        getMyInternship: (state) => state.myInternship,
        getTotal: (state) => state.total,
    },
};
